import { ChatState, MessageData, MessageUpdate } from './message.interface';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: null
})
export class ChatService {
  private commandSubject = new BehaviorSubject<MessageData | undefined>(undefined);
  private messageSubject = new BehaviorSubject<MessageData | undefined>(undefined);
  private messageUpdate = new BehaviorSubject<MessageUpdate | undefined>(undefined);

  createSenderMessage(content: string, placeholderMsg: string) {
    const idmsg = `msg_send_${new Date().getTime()}`;
    this.messageSubject.next({id: idmsg, content: content, datetime: new Date(), sender: true, state: 'start'})
    return this.createReceiverMessage(placeholderMsg);
  }

  private createReceiverMessage(placeholderMsg: string) {
    const idmsg = `msg_recv_${new Date().getTime()}`;
    this.messageSubject.next({id: idmsg, content: placeholderMsg, datetime: new Date(), sender: false, state: 'start'})
    return idmsg;
  }

  createCommandMessage(contentString: string) {
    const idmsg = `msg_recv_${new Date().getTime()}`;
    this.commandSubject.next({id: idmsg, content: contentString, datetime: new Date(), sender: false, state: 'finish'})
  }

  writeReceiverSampleMessage(msgId: string, content: string, state: ChatState) {
    this.messageUpdate.next({id: msgId, content: content, typing: false, state: state});
  }

  writeReceiverTypingMessage(msgId: string, content: string, state: ChatState) {
    this.messageUpdate.next({id: msgId, content: content, typing: true, state: state});
  }

  writeReceiverErrorMessage(msgId: string, content: string) {
    this.messageUpdate.next({id: msgId, content: content, typing: false, state: 'error'});
  }

  public createdMessage$() {
      return this.messageSubject;
  }

  public updatedMessage$() {
    return this.messageUpdate;
  }

  public commandMessage$() {
    return this.commandSubject;
  }

}
